import React, { Component } from "react";
//import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { switchLanguage } from "actions/Setting";
import MainApp from "app/index";
import "assets/vendors/style";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
import { postUserOtherAuthCheck } from "../api/auth";
import { getProjectAllApi } from "../api/project";
import AppLocale from "../lngProvider";

import {
  setUser,
  userSignIn,
  userSignInSuccess,
  userUpdate,
} from "actions/Auth";
import {
  setMyProjects,
  setProjects,
  setTDKProjects
} from "actions/Item";
import {
  fetchMessages
} from "actions/Messages";
import config from "../config";



import { LocalizationProvider } from '@mui/x-date-pickers';
import { IntlProvider } from "react-intl";
import languageData from "../components/LanguageSwitcher/data";
import  { mainTheme } from "./themes/main/default";

import enLocale from "date-fns/locale/en-US";
import ruLocale from "date-fns/locale/ru";
import trLocale from "date-fns/locale/tr";
import Item from "./Item";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import ItemReviewCorrect from "./ItemReviewCorrect";
import ItemPreviewPage from "./ItemPreviewPage";
import {mainTheme as mainTheme2 } from "./themes/main/theme3";

class App extends Component {
  componentDidMount = async () => {
    const paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);
    const token = params.get("t") !== null ? params.get("t").split("?")[0]: null;
    const language = params.get("t") !== null ?  params.get("t").split("?")[2] : null ;
    const url = params.get("t") !== null ?  params.get("t").split("?")[3] : null;
    const projectId = params.get("t") !== null ?  params.get("t").split("?")[4] : null;





    const pathname = this.props.location.pathname;

   //console.log("this.props pathName",pathname,this.props)

    if(pathname.includes("showItem") || pathname.includes("BelgeDogrulama"))
    {
     //console.log("kullanıcı kontrolü yapılmadan devam");
    }
    else 
    {
      if (token === null) {
        if (
          localStorage.getItem("userTokenTSYS") === null || localStorage.getItem("userTokenTSYS") === "null"
        ) {
          localStorage.removeItem("userTokenTSYS");
          window.location.href = config.mainPageUrl + `?status=false&message=Yetkisiz erişim`;
        }
      }
  
      const data = { token};
  
      if (   localStorage.getItem("userTokenTSYS") === null ||     localStorage.getItem("userTokenTSYS") === "null" || !(localStorage.getItem("userTokenTSYS") !== token && token === null && localStorage.getItem("userTokenTSYS") !== null ) //Buraya sonra bakacağız
      ) 
      {
     //   console.log(" localStorage. ", localStorage.getItem("userTokenTSYS") , token)
      //  console.log("buaraya girdi çünkü ", localStorage.getItem("userTokenTSYS") === null ,  localStorage.getItem("userTokenTSYS") === "null" ,!(localStorage.getItem("userTokenTSYS") !== token && token === null && localStorage.getItem("userTokenTSYS") !== null)  )

        //burası dil ile ilgili.

        this.props.switchLanguage({
          languageId: "turkish",
          locale: "tr",
          name: "Türkçe",
          icon: "tr",
        });




        localStorage.setItem("userTokenTSYS", token);
  
        const result = await postUserOtherAuthCheck(data).catch((error) => {
          return error.response.status === 403
            ? {
                status: false,
                message:
                  this.props.locale.locale === "tr"
                    ? "Hata Oluştu. Oturum sona erdi."
                    : "Error oncurred. Session failed",
              }
            : { status: false, message: "Error :" + error };
          //return null;
        });


  
    //   console.log("******************************************* result", result);
        if (result.status) {
          const { user } = result;
  
          this.props.fetchMessages(user.id);

          const resultProjects = await getProjectAllApi(); 

          
          if(resultProjects.status){
            const myProjectId = user.userRoles.filter(x=>x.id>359 && x.id < 369).map(x=>x.customId)
            const myProjects = resultProjects.data.filter(x=> myProjectId.some(y=>y === x.id) && x.projectType !== 3);

            this.props.setProjects(resultProjects.data);
            localStorage.setItem("projects",JSON.stringify(resultProjects.data));


            if(user.userRoles.id>359 && user.userRoles.id < 365)
            {

              this.props.setMyProjects(myProjects)
              localStorage.setItem("myProject",JSON.stringify(myProjects))

            }
            else if (user.userRoles.some(x=>x.id === 1 || x.id === 364))
            {
              this.props.setMyProjects(resultProjects.data.filter(x=>x.projectType !== 3 && x.projectType !== 4))
              localStorage.setItem("myProject", JSON.stringify(resultProjects.data))
            }
            else
            {

            }
         //   console.log("user.userRoles 2222222222 ",user.userRoles,myProjectId ,myProjects )

          }

          await this.props.userSignIn({ user, token });
          localStorage.setItem("userTokenTSYS", token);
          

          

         


          if (url === "/says/sendItem")
            return <Redirect to={"/says/sendItemPage/" + projectId} />;
          else if (url === "/says/adviceItem")
            return <Redirect to={"/says/adviceItemPage/" + projectId} />;
          else 
           return <Redirect to={"/says/mainPage"} />;
        } 
        else 
        { 
          localStorage.removeItem("userTokenTSYS");
          const { message } = result;
          console.log("message ",message)
         window.location.href =  config.mainPageUrl + `?status=false&message=${message}`;
        }
      } else {

        const user = this.props.authUser;

        console.log('***** user ', user)

        const resultProjects = await getProjectAllApi(); 

          
        if(resultProjects.status){
          const myProjectId = user.userRoles.filter(x=>x.id>359 && x.id < 369).map(x=>x.customId)
          const myProjects = resultProjects.data.filter(x=> myProjectId.some(y=>y === x.id));

          this.props.setProjects(resultProjects.data);
          localStorage.setItem("projects",JSON.stringify(resultProjects.data));
          this.props.setMyProjects(user.userRoles.some(x=>x.id === 1 || x.id === 364) ? resultProjects.data : myProjects)
          localStorage.setItem("myProject",JSON.stringify(user.userRoles.some(x=>x.id === 1 || x.id === 364) ? resultProjects.data : myProjects))


        }


 
        return <Redirect to={"/says/mainPage"} />;
      }
  
    }
  };


  render() {
   //console.log("app render oldu ");
    const {
      match,
      location,
      locale,
      showMessage,
      alertMessage,
    } = this.props;

    const paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);
    const projectId = params.get("pid");



    let applyTheme = createTheme( mainTheme2 ); 
  
    


    if (location.pathname === "/" && this.props.user !== null) {
      return <Redirect to={"/says/mainPage"} />;
    } else if (
      location.pathname === "/says/sendItem" &&
      this.props.user !== null
    ) {
      return <Redirect to={`/says/sendItemPage/${projectId}`} />;
    }



    const currentAppLocale = AppLocale[locale.locale];
    return (
      <ThemeProvider theme={applyTheme}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
        >
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
          
              <div className="app-main">
                <Switch>
                  <Route path={`${match.url}says`} component={MainApp} />
                  <Route path={`/showItem/:uid`} component={Item} />
                  <Route path={`/showItemPreview/:uid`} component={ItemPreviewPage} />
                  <Route
                    path={`/inceleyiciBelgeDogrulama`}
                    component={ItemReviewCorrect}
                  />

                  <Route
                    component={asyncComponent(() =>
                      import("components/Error404")
                    )}
                  />
                </Switch>
                {showMessage && NotificationManager.error(alertMessage)}
                <NotificationContainer />
              </div>
           
          </IntlProvider>
        </LocalizationProvider>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }, state) => {
  // //console.log("appp js state", state);
  const {
    themeColor,
    sideNavColor,
    darkTheme,
    locale,
    isDirectionRTL,
  } = settings;

  const user = state.authUser;
  const { alertMessage, showMessage, authUser } = auth;
  return {
    themeColor,
    sideNavColor,
    isDarkTheme: darkTheme,
    locale,
    isDirectionRTL,
    user,
    showMessage,
    alertMessage,
    authUser,
  };
};

export default connect(mapStateToProps, {
  userUpdate,
  userSignIn,
  userSignInSuccess,
  setUser,
  switchLanguage,
  fetchMessages,
  setProjects,
  setMyProjects,
  setTDKProjects
})(App);
